import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { authApi } from '@/services/api';

const HEARTBEAT_MS = 2 * 60 * 1000;

/**
 * Periodikus aktivitás-jelzés, amíg a felhasználó be van jelentkezve és a lap látható.
 */
export function useActivityHeartbeat() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    const ping = () => {
      if (document.visibilityState !== 'visible') return;
      authApi.heartbeat().catch(() => {
        /* csendes hiba – nem kritikus */
      });
    };

    ping();
    const interval = setInterval(ping, HEARTBEAT_MS);

    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        ping();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [isAuthenticated]);
}
